import React from 'react';


interface PodcastProps {
  url?: string | undefined
}

export default function Podcast({url}: PodcastProps) {
  return (
    <div>
      <iframe
        className="podcast__iframe"
        src={url}
        width="100%"
        height="152"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
    </div>
  )
}
